import React from 'react';

function ByElections() {
  return (
    <div>
      <h1>Local Spiritual Assembly By-elections</h1>
      <br />
      <ul className="plain-list">
        <li>
          <strong>Download:</strong>{' '}
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/20250909+All+LSAs+-+Reporting+by-elections.pdf">
            9 Sep 2025 Letter from the NSA to all LSAs about reporting by-elections (PDF)
          </a>
        </li>
        <li>
          <strong>Download:</strong>{' '}
          <a href="https://bahai-web.s3.us-east-1.amazonaws.com/RBC_elections/2025/Instructions+on+reporting+by-elections.pdf">
            Reporting By-elections of Local Spiritual Assemblies <em>updated August 2025</em> (PDF)
          </a>
        </li>
        <li>
          <strong>Download:</strong>{' '}
          <a href="https://bahai-web.s3.amazonaws.com/RBC_elections/2024/By-Election+form.pdf">By-election form (PDF)</a>
        </li>
      </ul>
    </div>
  );
}

export default ByElections;
